import type { BrandingConfig } from './types';

/**
 * BrandingConfig를 런타임에 적용한다.
 *
 * 동작: docs/06-branding.md §5.3 — colors를 CSS 변수로, title/favicon을 DOM에 주입.
 *
 * 다크모드 지원이나 추가 색상 토큰은 docs/07-open-issues.md §7.4 미정이므로,
 * 여기서는 spec에 명시된 primary/secondary/accent 만 처리한다.
 */
export function applyBranding(branding: BrandingConfig): void {
  if (typeof document === 'undefined') {
    // SSR 등 DOM이 없는 환경에서는 no-op
    return;
  }

  const root = document.documentElement;
  root.style.setProperty('--ax-color-primary', branding.colors.primary);
  root.style.setProperty('--ax-color-secondary', branding.colors.secondary);
  if (branding.colors.accent) {
    root.style.setProperty('--ax-color-accent', branding.colors.accent);
  }

  document.title = branding.title;
  setFavicon(branding.logo.favicon);
}

function setFavicon(href: string): void {
  if (typeof document === 'undefined') return;

  const existing = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  const link = existing ?? document.createElement('link');
  link.rel = 'icon';
  link.href = href;
  if (href.endsWith('.svg')) {
    link.type = 'image/svg+xml';
  } else {
    link.removeAttribute('type');
  }
  if (!existing) {
    document.head.appendChild(link);
  }
}
